import ConnectedSideNavBar from "../ConnectedSideNavBar";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ConnectedLayout({ children }: ProtectedRouteProps) {
  return (
    <div className="flex flex-row bg-background h-screen overflow-hidden">
      {/* This z index is used for the notifcations sidebar, otherwise it will be hidden by other content */}
      <div className="fixed h-screen z-10">
        <ConnectedSideNavBar />
      </div>

      <div className="flex-1 ml-64 pt-4 pr-4 pb-4 overflow-y-auto">
        <div className="rounded-lg border border-input bg-dark min-h-screen">
          <div className="max-w-[1800px] p-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
